import { render, staticRenderFns } from "./MatchWinnersPanel.vue?vue&type=template&id=a292599c&"
import script from "./MatchWinnersPanel.vue?vue&type=script&lang=js&"
export * from "./MatchWinnersPanel.vue?vue&type=script&lang=js&"
import style0 from "./MatchWinnersPanel.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports